import { Turbo } from "@hotwired/turbo-rails"
import "@37signals/lexxy"
import "./controllers"
import { confirmDialog } from "./dialogs/confirm"
import { MUTE_CONFIRMS } from "./dialogs/mute_copy"

// Replace Turbo's native confirm() with our styled dialog. A form/submitter can
// either reuse a shared mute dialog (data-mute-confirm-kind/value, so the same
// modal shows here and from the inline link/hashtag menu) or supply its own copy
// via data-confirm-* attributes.
Turbo.config.forms.confirm = (message, formElement, submitter) => {
  const source = submitter || formElement
  const data = source.dataset

  const muteConfirm = MUTE_CONFIRMS[data.muteConfirmKind]
  if (muteConfirm) return confirmDialog(muteConfirm(data.muteConfirmValue))

  return confirmDialog({
    title: data.confirmTitle,
    body: message,
    accept: data.confirmAccept,
    linkUrl: data.confirmLinkUrl,
    linkLabel: data.confirmLinkLabel
  })
}

